import { useAuthStore } from '@/store/useAuthStore'

/**
 * Accounts that log in as admin but must not reach the sensitive parts of the
 * panel (creating other admins, changing global app settings). Matched on the
 * login email, case-insensitively.
 */
const RESTRICTED_EMAILS = ['sharjah@gov.ae']

export function isRestrictedAccount(email?: string | null) {
  return RESTRICTED_EMAILS.includes(String(email ?? '').trim().toLowerCase())
}

/** What the logged-in account is allowed to see/do. */
export function useAccountRestrictions() {
  const user = useAuthStore(s => s.user)
  const email = (user as any)?.email ?? (user as any)?.user?.email
  const restricted = isRestrictedAccount(email)
  return {
    restricted,
    canCreateAdmin:        !restricted,
    canSeeAppSettings:     !restricted,
    canSeeVehicleCategory: !restricted,
    /** Nav paths a restricted account must not see. */
    hiddenPaths: restricted ? RESTRICTED_PATHS : [],
  }
}

/** Sidebar entries removed for restricted accounts. */
export const RESTRICTED_PATHS = [
  '/dashboard/system/app-settings',
  '/dashboard/category',
]
